import { render, staticRenderFns } from "./supervisorsItem.vue?vue&type=template&id=571b841b&"
import script from "./supervisorsItem.vue?vue&type=script&lang=js&"
export * from "./supervisorsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports